// Module
var code = `<condition ng-if="\$ctrl.propertyDefinition.type === \$ctrl.type"
           conditions="\$ctrl.conditions"
           property="\$ctrl.propertyDefinition.property">
  <div class="condition-container">
    {{\$ctrl.propertyDefinition.label}}

    <select ng-model="\$ctrl.model.param1"
            required
            ng-change="\$ctrl.valueChanged()"
            ng-options="option.id as option.label for option in \$ctrl.options">
    </select>
    <input type="text"
           ng-model="\$ctrl.model.param2"
           maxlength="255"
           ng-disabled="!\$ctrl.model.param1"
           required>
  </div>
</condition>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/compliance/risk-profiling/conditions/single-select-and-text-condition.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;